'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFocusRing } from 'react-aria';
import { Card } from '../Card/Card';
import { focusRing } from '../system/motion';
/**
 * Card whose entire surface navigates to `href`. An invisible <a> is
 * absolutely positioned over the card body — clicks on the body, title,
 * or any non-positioned descendant fire the link. Wrap inner controls
 * that must remain interactive (RSVP, bookmark, menu) in <CardLinkAction>.
 * The anchor is marked `data-card-link-overlay`: content beneath it that
 * follows the pointer (hit-testing its own parts) listens on the anchor's
 * parent, the card.
 */
export function CardLink({ href, ariaLabel, linkAs, onNavigate, children, style, ...cardProps }) {
    const Anchor = linkAs ?? 'a';
    const { isFocusVisible, focusProps } = useFocusRing();
    return (_jsxs(Card, { ...cardProps, interactive: true, style: {
            position: 'relative',
            ...focusRing(isFocusVisible),
            ...style,
        }, children: [_jsx(Anchor, { href: href, "aria-label": ariaLabel, "data-card-link-overlay": "", ...focusProps, ...(onNavigate === undefined ? {} : { onClick: () => onNavigate() }), style: {
                    position: 'absolute',
                    inset: 0,
                    zIndex: 'var(--z-card-overlay)',
                    color: 'inherit',
                    textDecoration: 'none',
                    borderRadius: 'var(--radius-lg)',
                } }), children] }));
}
/** Marks a child of <CardLink> as interactive (raises above the overlay anchor). */
export function CardLinkAction({ children, style, }) {
    return (_jsx("div", { style: { position: 'relative', zIndex: 'var(--z-card-action)', display: 'inline-flex', ...style }, children: children }));
}
//# sourceMappingURL=CardLink.js.map